var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGauge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4202 6.67511C14.3242 6.22486 13.1502 5.99543 11.9654 5.99999L11.9651 5.99999C7.00717 6.01727 3 10.1155 3 15.1031V17.25H21V15C21 13.8152 20.7661 12.642 20.3116 11.5478C19.8572 10.4536 19.1911 9.45994 18.3517 8.62376C17.5123 7.78758 16.5161 7.12537 15.4202 6.67511ZM11.9599 4.5C13.3421 4.49472 14.7117 4.76239 15.9902 5.28765C17.2688 5.81294 18.4311 6.58552 19.4104 7.56107C20.3897 8.53661 21.1667 9.69592 21.6969 10.9725C22.2271 12.249 22.5 13.6177 22.5 15V17.25C22.5 17.6478 22.342 18.0293 22.0607 18.3107C21.7794 18.592 21.3978 18.75 21 18.75H3C2.60218 18.75 2.22065 18.592 1.93934 18.3107C1.65803 18.0294 1.5 17.6478 1.5 17.25V15.1031C1.5 9.30958 6.15519 4.52037 11.9596 4.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C12.4142 4.5 12.75 4.83579 12.75 5.25V8.25C12.75 8.66421 12.4142 9 12 9C11.5858 9 11.25 8.66421 11.25 8.25V5.25C11.25 4.83579 11.5858 4.5 12 4.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.85358 12.2842C1.96071 11.884 2.37192 11.6465 2.77204 11.7536L5.67829 12.5318C6.07841 12.6389 6.31593 13.0501 6.2088 13.4502C6.10167 13.8503 5.69046 14.0879 5.29034 13.9807L2.38409 13.2026C1.98397 13.0955 1.74646 12.6843 1.85358 12.2842Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1463 12.2842C22.2534 12.6843 22.0159 13.0955 21.6158 13.2026L18.7095 13.9807C18.3094 14.0879 17.8982 13.8503 17.7911 13.4502C17.684 13.0501 17.9215 12.6389 18.3216 12.5318L21.2278 11.7536C21.628 11.6465 22.0392 11.884 22.1463 12.2842Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.563 9.05196C16.8915 9.30419 16.9534 9.77501 16.7012 10.1036L10.2887 18.4567C10.0364 18.7853 9.56562 18.8471 9.23706 18.5949C8.9085 18.3427 8.84662 17.8719 9.09885 17.5433L15.5113 9.19017C15.7636 8.86161 16.2344 8.79973 16.563 9.05196Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.3ced068ac3ad290c989f486625b69719.svg";
export { ForwardRef as ReactComponent };